export const ConfirmIcon = ({ fillColor = '#479747' }: { fillColor?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.50055 15.5302L18.3089 6.72187C18.468 6.56354 18.6563 6.48438 18.874 6.48438C19.0917 6.48438 19.2825 6.56383 19.4464 6.72275C19.6047 6.88167 19.6839 7.06986 19.6839 7.28732C19.6839 7.50479 19.6047 7.69269 19.4464 7.85103L10.063 17.2344C9.89916 17.3983 9.71166 17.4802 9.50055 17.4802C9.28943 17.4802 9.1047 17.3983 8.94637 17.2344L4.54637 12.8344C4.38249 12.6753 4.30402 12.4869 4.31097 12.2692C4.3179 12.0515 4.40083 11.8635 4.55975 11.7052C4.71866 11.5469 4.90685 11.4677 5.12432 11.4677C5.3418 11.4677 5.53249 11.5469 5.69637 11.7052L9.50055 15.5302Z"
      fill={fillColor}
    />
  </svg>
);

